export const conflictingSources: string[] = [
  'One video explains how to thread the machine.',
  'A book chapter covers drafting a skirt block.',
  'A handout from years ago explains inserting a zipper.',
  'Your old notes cover body measurements.',
]

export const symptoms: string[] = [
  'And when you need material for machine basics, fabrics, measurements, pattern drafting, draping, fitting, construction or tailoring...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next class or workshop arrives.'

export const needsList: string[] = [
  'You need a clear visual of the machine, the pattern or the technique.',
  'You need the construction steps broken down one by one.',
  'You need studio drills and practice samples that actually engage your students.',
  'You need ❌/✅ comparisons that correct the most common sewing mistakes.',
  'And you need a clear way to see who is really ready for the next project.',
]

export const searchQuestions: string[] = [
  'What should I teach in today’s class?',
  'How do I explain thread tension so students set it correctly every time?',
  'How do I teach body measurements and pattern drafting step by step?',
  'How do I correct a zipper or a collar that keeps coming out crooked?',
  'How do I make darts, ease and seam allowances click for every student?',
  'How do I give feedback at the machine without discouraging anyone?',
  'Where do I find clear visual material for draping, fitting and tailoring?',
  'How can I plan better classes without spending hours every week?',
]

export const painPoints: string[] = [
  'Rebuilding classes and workshops from scratch every week.',
  'Hours searching scattered books, videos, handouts and notes.',
  'Explaining drafting, fitting and construction steps with words alone.',
  'Students following steps without understanding why.',
  'No visual material for the studio, the cutting table or the dress form.',
  'Repeating the same corrections every class.',
  'Assessing skills and finished garments without clear criteria.',
  'Losing time you could spend actually teaching.',
  'And constantly wondering if your next class will be good enough.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO CORRECT ERRORS.',
  'HOW TO STRUCTURE THE CLASS.',
  'HOW TO ASSESS EACH SKILL.',
]
